export default class Standard {
  constructor(standard = {}) {
    this.id = standard.id || null
    this.name = standard.name || null
    this.checkpoints = standard.checkpoints || []
  }

  mutations() {
    return {
      setStandard: (state, standard) => state.standard = new Standard(standard),
      clearStandard: (state) => state.standard = new Standard(),
    }
  }
}